import React, { useState, useEffect } from "react";

import {
  Button,
  FormControl,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Grid,
  Snackbar,
  IconButton,
  InputLabel,
  Card, CardContent, Menu, Typography,
  Box,
} from "@mui/material";

import { DataGrid } from "@mui/x-data-grid";
import MoreVertIcon from '@mui/icons-material/MoreVert';




import { ReactComponent as EditIcon } from "../../assets/img/Edit.svg";

import { ReactComponent as DeleteIcon } from "../../assets/img/Delete.svg";

import { useRecoilState, useRecoilValue } from 'recoil';

import AddIcon from "@mui/icons-material/Add";

import AddArea from "./AddArea";

import AddUser from "./AddUser";
import AddPlant from "./AddPlant";
import Dialog from "@mui/material/Dialog";

import DialogTitle from "@mui/material/DialogTitle";

import DialogActions from "@mui/material/DialogActions";
import axios from "axios";
import MuiAlert from "@mui/material/Alert";
import configParam from "../../config";

import { UserSettings } from '../../recoil/atoms';

const sortByDateDesc = (a, b) => {
  const getTimestamp = (item) => {
    const val = item.created_on || item.created_at || item.addedOn || item.addedon;
    if (!val) return 0;
    const d = new Date(val);
    return isNaN(d.getTime()) ? 0 : d.getTime();
  };
  const timeA = getTimestamp(a);
  const timeB = getTimestamp(b);
  if (timeB !== timeA) {
    return timeB - timeA;
  }
  const idA = typeof a.id === 'number' ? a.id : parseInt(a.id) || 0;
  const idB = typeof b.id === 'number' ? b.id : parseInt(b.id) || 0;
  return idB - idA;
};

const cardStyle = {
  width: '100%',
  height: '168px',
  marginBottom: '10px',
  padding: '10px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  border: '1px solid  #E0E0E0',
  marginRight: '18px', // Add margin to the right of each card


};
const contentStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flex: 1,
};
const topRightCornerStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginBottom: '15px',
};


const YearSelectBox = ({ selectedYear, years, onSelectedYearChange }) => {


  return (
    <FormControl fullWidth>
      <Select
        value={selectedYear}
        onChange={onSelectedYearChange}
        className="select-nis"
        size="small"
        displayEmpty
      >
        <MenuItem value="">All Years</MenuItem>
        {years.map((year, index) => (
          <MenuItem key={index} value={year.year}>
            {year.year}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};



function Settings() {
  const [userDet, setUserDet] = useState({});

  const [activeTab, setActiveTab] = useState("area");
  const [access_token, setAccessToken] = useState(localStorage.getItem("accesstoken"))

  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [currentaddedPlants, setCurrentAddedPlants] = useState([]);
  const [addAreaModalOpen, setAddAreaModalOpen] = useState(false);
  const [addPlantModalOpen, setAddPlantModalOpen] = useState(false);
  const [addUserModalOpen, setAddUserModalOpen] = useState(false);
  const [currentaddedAreas, setCurrentAddedAreas] = useState([]);
  const [addedAreas, setAddedAreas] = useState([]);
  const [addedPlants, setAddedPlants] = useState([]);
  const [currentaddedUsers, setCurrentAddedUsers] = useState([]);
  const [addedUsers, setAddedUsers] = useState([]);
  const [iconsVisibleArea, setIconsVisibleArea] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedRowUserData, setSelectedRowUserData] = useState(null);
  const [selectedRowPlantData, setSelectedRowPlantData] = useState(null);
  const [selectedCardData, setSelectedCardData] = useState(null);
  const [selectedUserCardData, setSelectedUserCardData] = useState(null);
  const [selectedPlantCardData, setSelectedPlantCardData] = useState(null);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);

  const [alertMessage, setAlertMessage] = useState("");
  const ApiURL = configParam.API_URL;
  const [areaRows, setAreaRows] = useState([]);
  const [selectedUserYear, setSelectedUserYear] = useState("");
  const [selectedAreaYear, setSelectedAreaYear] = useState("");
  const [areaFilter, setAreaFilter] = useState("");
  const [uniqueAreas, setUniqueAreas] = useState([]);
  const [userDataSettings, setUserDataSettings] = useRecoilState(UserSettings)
  const [isYearSelected, setIsYearSelected] = useState(false);

  const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null);
  const [activeCardData, setActiveCardData] = useState(null);
  const [visibleUsersCount, setVisibleUsersCount] = useState(10);
  const [visibleAreasCount, setVisibleAreasCount] = useState(10);
  const [visiblePlantsCount, setVisiblePlantsCount] = useState(10);

  const handleOpenMobileMenu = (event, data) => {
    setMobileMenuAnchor(event.currentTarget);
    setActiveCardData(data);
  };

  const handleCloseMobileMenu = () => {
    setMobileMenuAnchor(null);
    setActiveCardData(null);
  };

  useEffect(() => {
    setVisibleUsersCount(10);
    setVisibleAreasCount(10);
    setVisiblePlantsCount(10);
  }, [activeTab, areaFilter, selectedUserYear, selectedAreaYear]);

  const tabStyle = (value) => ({
    fontWeight: activeTab === value ? 600 : 500,
    fontSize: activeTab === value ? "16px" : "16px",
    color: activeTab === value ? "#000000" : "#000000CC",
    padding: "0 32px",
  });
  const tabStyleMobile = (value) => ({
    fontWeight: activeTab === value ? 600 : 500,
    fontSize: activeTab === value ? "12px" : "12px",
    color: activeTab === value ? "#002060" : "#64748B",
    padding: "6px 8px",
    textTransform: "none",
    minWidth: "auto",
  });
  useEffect(() => {
    let data = localStorage.getItem("user");
    let User = JSON.parse(data);
    setUserDet(User);
  }, []);
  useEffect(() => {
    if (userDet) {
      setIconsVisibleArea(userDet.role_id === 3);
    }
  }, [userDet]);

  useEffect(() => {
    // Function to check for accessToken changes
    const handleAccessTokenChange = () => {
      const storedAccessToken = localStorage.getItem("accesstoken");
      if (storedAccessToken !== access_token) {
        setAccessToken(storedAccessToken);
      }
    };

    // Listen for storage events (for cross-tab changes)
    window.addEventListener("storage", handleAccessTokenChange);

    // Check for changes every second (for same-tab changes)
    const interval = setInterval(handleAccessTokenChange, 1000);

    // Cleanup listeners and interval on component unmount
    return () => {
      window.removeEventListener("storage", handleAccessTokenChange);
      clearInterval(interval);
    };
  }, [access_token]); // Dependency on accessToken

  useEffect(() => {
    let data = localStorage.getItem("user");
    let User = JSON.parse(data)

    setUserDet(User);
  }, [userDataSettings]);


  useEffect(() => {
    // Retrieve unique area values from the addedAreas array
    const uniqueAreaValues = [...new Set(addedAreas.map(area => area.plantName))].sort((a, b) => a.localeCompare(b));

    setUniqueAreas(uniqueAreaValues);
  }, [addedAreas]);

  const handleAreaFilterChange = (event) => {
    const newAreaFilter = event.target.value;
    setAreaFilter(newAreaFilter);
  };

  const filteredAreaRows = areaFilter
    ? addedAreas.filter((area) =>
      area && area.plantName && area.plantName.toLowerCase().includes(areaFilter.toLowerCase())
    )
    : addedAreas;
  useEffect(() => {
    const filteredAreaRows1 = areaFilter
      ? addedAreas.filter((area) =>
        area && area.plantName && area.plantName.toLowerCase().includes(areaFilter.toLowerCase())
      )
      : addedAreas;

    const sortedFilteredAreaRows = [...filteredAreaRows1].sort(sortByDateDesc);

    setAreaRows(sortedFilteredAreaRows.map((area, index) => ({
      id: area.id ?? index + 1,
      slNo: index + 1,
      location: (area.location || "").toUpperCase(),
      business: (area.business_name || "").toUpperCase(),
      plant: (area.plantName || "").toUpperCase(),
      area: (area.area?.charAt(0) || "").toUpperCase() + (area.area || "").slice(1).toLowerCase(),
      description: area.description,
      addedBy: area.name,
      addedOn: area.created_on ? area.created_on.split("T")[0] : "",
    })))
  }, [addedAreas, areaFilter]);

  const [years, setYears] = useState([]);

  const areaRowsFromData = [...addedAreas].sort(sortByDateDesc).map((area, index) => ({
    id: area.id ?? index + 1,
    slNo: index + 1,
    location: (area.location || "").toUpperCase(),
    business: (area.business_name || "").toUpperCase(),
    plant: (area.plantName || "").toUpperCase(),
    area: (area.area?.charAt(0) || "").toUpperCase() + (area.area || "").slice(1).toLowerCase(),
    description: area.description,
    addedBy: area.name,
    addedOn: area.created_on ? area.created_on.split("T")[0] : "",
  }));

  const fetchYears = async () => {
    try {
      const response = await axios.get(ApiURL + "/show_user_year", {
        headers: {
          Authorization: `Bearer ${access_token}`,

        }
      }
      ); // Replace with your API endpoint
      const sortedYears = [...response.data].sort((a, b) => Number(a.year) - Number(b.year));
      setYears(sortedYears);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };

  useEffect(() => {
    fetchYears();
  }, []);



  const handleOpenAlert = (message) => {
    setAlertMessage(message);
    setAlertOpen(true);
  };

  const handleCloseAlert = () => {
    setAlertOpen(false);
  };
  useEffect(() => {
    // Fetch user details whenever the user settings tab becomes active
    if (activeTab === "user") {
      getuserDetails();
    }
  }, [activeTab]);
  const handleTabChange = (event, newTab) => {
    setActiveTab(newTab);
    // Reload so a plant edited on the other tab is reflected here straight away
    if (newTab === 'area') {
      getareaDetails();
    } else if (newTab === 'plant') {
      getplantDetails();
    }
  };

  const handleAddAreaClick = () => {
    setAddAreaModalOpen(true);
  };
  const handleAddPlantClick = () => {
    setAddPlantModalOpen(true);
  }
  const handleAddUserClick = () => {
    setAddUserModalOpen(true);
  };

  const handleAddAreaModalClose = () => {
    setSelectedRowData(null);
    setSelectedCardData(null);
    setAddAreaModalOpen(false);
  };
  const handleAddPlantModalClose = () => {
    setSelectedRowPlantData(null);
    setSelectedPlantCardData(null);
    setAddPlantModalOpen(false);
  };
  const handleAddUserModalClose = () => {
    setSelectedRowUserData(null);
    setSelectedUserCardData(null);
    setAddUserModalOpen(false);
  };

  const handleSaveArea = (newArea) => {
    const targetId = selectedRowData?.id ?? selectedCardData?.id ?? newArea?.id ?? null;
    if (targetId) {
      setAddedAreas((prev) => prev.map((item) => (item.id === targetId ? { ...item, ...newArea } : item)));
    } else {
      setAddedAreas((prev) => [...prev, { ...newArea, id: newArea?.id ?? Date.now() }]);
    }
    setSelectedRowData(null);
    setSelectedCardData(null);
    setAddAreaModalOpen(false);
    getareaDetails();
  };

  const handleSaveUser = (newUser) => {
    const targetId = selectedRowUserData?.id ?? selectedUserCardData?.id ?? newUser?.id ?? null;
    if (targetId) {
      setAddedUsers((prev) => prev.map((item) => (item.id === targetId ? { ...item, ...newUser } : item)));
    } else {
      setAddedUsers((prev) => [...prev, { ...newUser, id: newUser?.id ?? Date.now() }]);
    }
    setSelectedRowUserData(null);
    setSelectedUserCardData(null);
    setAddUserModalOpen(false);
    getuserDetails();
  };
  const handleSavePlant = (newPlant) => {
    // The save payload only holds ids (business/location/category), so it must not be merged into the
    // displayed rows (that put the location id in the Location column and left a stale extra row).
    // The list is reloaded from the server below instead.
    setAddPlantModalOpen(false);
    setSelectedRowPlantData(null);
    setSelectedPlantCardData(null);
    getplantDetails();
    getareaDetails(); // area rows show the plant name, which may just have changed
  };


  const deleteArea = (areaId) => {

    const url = ApiURL + "/delete_area"; // Replace with your backend API endpoint to delete area
    axios
      .delete(url, {
        data: { areaId: areaId }, headers: {
          Authorization: `Bearer ${access_token}`,

        }
      }
      )
      .then((response) => {
        getareaDetails();
      })
      .catch((error) => {
        // Handle error
        console.error("Failed to delete area:", error);
      });
  };
  const deleteUser = (userId) => {
    const url = ApiURL + "/delete_user"; // Replace with your backend API endpoint to delete area
    axios
      .delete(url, {
        data: { userId: userId }, headers: {
          Authorization: `Bearer ${access_token}`,

        }
      }
      )
      .then((response) => {
        getuserDetails();
      })
      .catch((error) => {
        // Handle error
        console.error("Failed to delete user:", error);
      });
  };
  const deletePlant = (plantId) => {
    const url = ApiURL + "/delete_plant"; // Replace with your backend API endpoint to delete area
    axios
      .delete(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,

        },
        data: {
          plantId: plantId
        }
      })

      .then((response) => {
        getplantDetails();
      })
      .catch((error) => {
        // Handle error
        console.error("Failed to delete user:", error);
      });
  };

  const handleConfirmDelete = () => {
    const deletionId = selectedItem ?? selectedDeleteItem?.id ?? null;
    if (!deletionId) {
      setConfirmationModalOpen(false);
      setSelectedItem(null);
      setSelectedDeleteItem(null);
      return;
    }

    if (activeTab === "area") {
      setAddedAreas((prev) => prev.filter((area) => area.id !== deletionId));
      deleteArea(deletionId);
      setAlertOpen(true);
      setAlertMessage("Area deleted successfully");
    }
    else if (activeTab === "plant") {
      setAddedPlants((prev) => prev.filter((plant) => plant.id !== deletionId));
      deletePlant(deletionId);
      setAlertOpen(true);
      setAlertMessage("Plant deleted successfully");
    }
    else {
      setAddedUsers((prev) => prev.filter((user) => user.id !== deletionId));
      deleteUser(deletionId);
      setAlertOpen(true);
      setAlertMessage("User deleted successfully");
    }

    setConfirmationModalOpen(false);
    setSelectedItem(null);
    setSelectedDeleteItem(null);
  };

  const handleCancelDelete = () => {
    setConfirmationModalOpen(false);

    setSelectedItem(null);
    setSelectedDeleteItem(null);
  };
console.log("addedUsers",addedUsers)
  const sortedUsersForRows = [...addedUsers].sort(sortByDateDesc);
  const userRows = sortedUsersForRows.map((user, index) => {
    let plant = [];
    if (user.plant_name !== null && user.plant_name !== undefined && user.plant_name.length > 0) {
      plant = user.plant_name.map((item) => item.toUpperCase());
    }

    return {
      id: user.id ?? index + 1,
      slNo: index + 1,
      sgid: user.sgid,
      name: user.name,
      location: (user.location || "").toUpperCase(),
      email: user.email,
      business: (user.business_name || "").toUpperCase(),
      role: (user.role_name || "").charAt(0).toUpperCase() + (user.role_name || "").slice(1),
      plant: plant,
      department: (user.department_name || "").charAt(0).toUpperCase() + (user.department_name || "").slice(1),
      
      addedBy: user.created_by,
      addedOn: user.created_on ? user.created_on.split("T")[0] : "",
    };
  });

  const sortedPlantsForRows = [...addedPlants].sort(sortByDateDesc);
  const plantRows = sortedPlantsForRows.map((area, index) => ({
    id: area.id ?? index + 1,
    slNo: index + 1,
    location: (area.location || "").toUpperCase(),
    business: (area.business_name || "").toUpperCase(),
    plant: (area.plantName || "").toUpperCase(),
    addedBy: area.name,
    category: area.category_name
  }));
  const OriginalareaColumns = [
    {
      field: "id",
      headerName: "S.No",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
      renderCell: (params) => params.row?.slNo ?? 1,
    },

    {
      field: "business",
      headerName: "Business",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "location",
      headerName: "Location",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "plant",
      headerName: "Plant",
      minWidth: 190,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "area",
      headerName: "Area",
      minWidth: 230,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
      renderCell: (params) => params.value,
      filterOptions: {
        renderValue: (value) => `Area: ${value}`,
      },
    },

    {
      field: "addedBy",
      headerName: "Added By",
      minWidth: 220,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "addedOn",
      headerName: "Added On",
      minWidth: 240,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "action",

      headerName: "Action",

      minWidth: 120,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => (
        iconsVisibleArea && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <IconButton 
              size="small" 
              onClick={() => handleEditClick(params.row)}
              sx={{
                color: '#64748B',
                '&:hover': { backgroundColor: '#f1f5f9', color: '#1e3a8a' }
              }}
            >
              <EditIcon style={{ width: '18px', height: '18px' }} />
            </IconButton>
            <IconButton 
              size="small" 
              onClick={() => {
                setSelectedItem(params.row.id);
                setConfirmationModalOpen(true);
              }}
              sx={{
                color: '#64748B',
                '&:hover': { backgroundColor: '#fee2e2', color: '#b91c1c' }
              }}
            >
              <DeleteIcon style={{ width: '18px', height: '18px' }} />
            </IconButton>
          </div>
        )
      ),
    },
  ];
  const OriginalplantColumns = [
    {
      field: "id",
      headerName: "S.No",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
      renderCell: (params) => params.row?.slNo ?? 1,
    },

    {
      field: "business",
      headerName: "Business",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "location",
      headerName: "Location",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "plant",
      headerName: "Plant",
      minWidth: 190,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },
    {
      field: "category",
      headerName: "Category",
      minWidth: 190,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },
    {
      field: "addedBy",
      headerName: "Added By",
      minWidth: 220,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "action",

      headerName: "Action",

      minWidth: 120,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => (
        iconsVisibleArea && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <IconButton 
              size="small" 
              onClick={() => handleEditClick(params.row)}
              sx={{
                color: '#64748B',
                '&:hover': { backgroundColor: '#f1f5f9', color: '#1e3a8a' }
              }}
            >
              <EditIcon style={{ width: '18px', height: '18px' }} />
            </IconButton>
            <IconButton 
              size="small" 
              onClick={() => {
                setSelectedItem(params.row.id);
                setConfirmationModalOpen(true);
              }}
              sx={{
                color: '#64748B',
                '&:hover': { backgroundColor: '#fee2e2', color: '#b91c1c' }
              }}
            >
              <DeleteIcon style={{ width: '18px', height: '18px' }} />
            </IconButton>
          </div>
        )
      ),
    },
  ];
  const columnsWithHiddenHeadersInner = OriginalareaColumns.map((column) => {
    if (column.field === 'action') {
      return {
        ...column,
        headerName: '',
        // Empty string to hide the header name
      };
    }
    return column;
  });
  const areaColumns = iconsVisibleArea ? OriginalareaColumns : columnsWithHiddenHeadersInner;


  const columnsWithHiddenHeadersplant = OriginalplantColumns.map((column) => {
    if (column.field === 'action') {
      return {
        ...column,
        headerName: '',
        // Empty string to hide the header name
      };
    }
    return column;
  });
  const plantColumns = iconsVisibleArea ? OriginalplantColumns : columnsWithHiddenHeadersplant;

  useEffect(() => {
    getareaDetails();
    getplantDetails();
  }, []);
  const getareaDetails = () => {
    let url = ApiURL + "/show_area";
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,

        }
      }
      )
      .then((response) => {
        setAddedAreas(response.data);
      })
      .catch((error) => {
        setAddedAreas([]);
      });
  };
  const getplantDetails = () => {
    let url = ApiURL + "/show_plant_details";
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,

        }
      }
      )
      .then((response) => {
        setAddedPlants(response.data);
      })
      .catch((error) => {
        setAddedPlants([]);
      });
  };
  useEffect(() => {
    getuserDetails();
  }, []);

  const getuserDetails = () => {
    let url = ApiURL + "/show_user";
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,

        }
      }
      )
      .then((response) => {
        setAddedUsers(response.data);
      })
      .catch((error) => {
        setAddedUsers([]);
      });
  };

  const handleEdit = (rowData) => {
    if (activeTab === "area") {

      setSelectedCardData(rowData);
      setAddAreaModalOpen(true);
      const areaId = rowData.id;
      let url = ApiURL + `/get_current_area/${areaId}`;
      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${access_token}`,

          }
        }
        )
        .then((response) => {
          setCurrentAddedAreas(response.data);

        })
        .catch((error) => {
          setCurrentAddedAreas([]);
        });
    }
    else if (activeTab === "plant") {
      setSelectedPlantCardData(rowData);
      setAddPlantModalOpen(true);
      const plantId = rowData.id;
      let url = ApiURL + `/get_current_plant/${plantId}`;
      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${access_token}`,

          }
        }
        )
        .then((response) => {
          setCurrentAddedPlants(response.data);
        })
        .catch((error) => {
          setCurrentAddedPlants([]);
        });
    } else {
      setSelectedUserCardData(rowData);
      setAddUserModalOpen(true);

      const userId = rowData.id;
      let url = ApiURL + `/get_current_users/${userId}`;
      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${access_token}`,

          }
        }
        )
        .then((response) => {
          setCurrentAddedUsers(response.data);
        })
        .catch((error) => {
          setCurrentAddedUsers([]);
        });

    }
  };
  const handleEditClick = (rowData) => {

    if (activeTab === "area") {
      setSelectedRowData(rowData);
      setAddAreaModalOpen(true);
      if (rowData && rowData.id) {
        let url = ApiURL + `/get_current_area/${rowData.id}`;
        axios
          .get(url, {
            headers: {
              Authorization: `Bearer ${access_token}`,

            }
          }
          )
          .then((response) => {
            setCurrentAddedAreas(response.data);

          })
          .catch((error) => {
            setCurrentAddedAreas([]);
          });
      }
    }
    else if (activeTab === "plant") {
      setSelectedRowPlantData(rowData);
      setAddPlantModalOpen(true);
      if (rowData && rowData.id) {
        let url = ApiURL + `/get_current_plant/${rowData.id}`;
        axios
          .get(url, {
            headers: {
              Authorization: `Bearer ${access_token}`,

            }
          }
          )
          .then((response) => {
            setCurrentAddedPlants(response.data);

          })
          .catch((error) => {
            setCurrentAddedPlants([]);
          });
      }
    }
    else {
      setSelectedRowUserData(rowData);
      setAddUserModalOpen(true);

      if (rowData && rowData.id) {
        let url = ApiURL + `/get_current_users/${rowData.id}`;
        axios
          .get(url, {
            headers: {
              Authorization: `Bearer ${access_token}`,

            }
          }
          )
          .then((response) => {
            setCurrentAddedUsers(response.data);

          })
          .catch((error) => {
            setCurrentAddedUsers([]);
          });
      }
    }
  };

  const userColumns = [
    {
      field: "id",
      headerName: "S.No",
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
      renderCell: (params) => params.row?.slNo ?? 1,
    },

    {
      field: "business",
      headerName: "Business",
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },
    {
      field: "location",
      headerName: "Location",
      minWidth: 120,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "plant",
      headerName: "Plant",
      minWidth: 130,
      align: "center",
      headerAlign: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "name",
      headerName: "Name",
      minWidth: 190,
      align: "center",
      headerAlign: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "sgid",
      headerName: "SGID",
      minWidth: 150,
      align: "center",
      headerAlign: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "role",
      headerName: "Role",
      minWidth: 140,
      align: "center",
      headerAlign: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "department",
      headerName: "Department",
      minWidth: 140,
      align: "center",
      headerAlign: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "addedBy",
      headerName: "Added By",
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },

    {
      field: "addedOn",
      headerName: "Added On",
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      cellClassName: 'custom-column-style',
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
          {(userDet.role_id === 1 && params.row.role === 'Super Admin') ? (
            <>
              <IconButton size="small" disabled sx={{ opacity: 0.5 }}>
                <EditIcon style={{ width: '18px', height: '18px' }} />
              </IconButton>
              <IconButton size="small" disabled sx={{ opacity: 0.5 }}>
                <DeleteIcon style={{ width: '18px', height: '18px' }} />
              </IconButton>
            </>
          ) : (
            <>
              <IconButton 
                size="small" 
                onClick={() => handleEditClick(params.row)}
                sx={{
                  color: '#64748B',
                  '&:hover': { backgroundColor: '#f1f5f9', color: '#1e3a8a' }
                }}
              >
                <EditIcon style={{ width: '18px', height: '18px' }} />
              </IconButton>
              <IconButton 
                size="small" 
                onClick={() => {
                  setSelectedItem(params.row.id);
                  setConfirmationModalOpen(true);
                }}
                sx={{
                  color: '#64748B',
                  '&:hover': { backgroundColor: '#fee2e2', color: '#b91c1c' }
                }}
              >
                <DeleteIcon style={{ width: '18px', height: '18px' }} />
              </IconButton>
            </>
          )}
        </div>
      ),
    }




  ];

  const paginatedRows = activeTab === 'area' ? areaRows : activeTab === 'plant' ? plantRows : userRows;


  const columns = activeTab === "area" ? areaColumns : activeTab === 'plant' ? plantColumns : userColumns;


  const handleSelectedYearChange = (event) => {
    const newYear = event.target.value;
    // Call the function from settingsResolver module with selectedYear as a parameter
    if (activeTab === "user") {
      getuserDateList(newYear);
      setSelectedUserYear(newYear); // Replace functionName with the actual function you want to call
    } else if (activeTab === "area") {
      setSelectedAreaYear(newYear);
      getAreaDateList(newYear);
    }
  };

  const getuserDateList = (yearz) => {
    const currentYear = yearz;
    let url = ApiURL + `/show_user/${currentYear}`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,

        }
      }
      )
      .then((response) => {
        setAddedUsers(response.data);
      })
      .catch((error) => {
        setAddedUsers([]);
      });
  };

  const getAreaDateList = (yearz) => {

    const currentYear = yearz;
    let url = ApiURL + `/show_area/${currentYear}`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,

        }
      }
      )
      .then((response) => {
        setAddedAreas(response.data);
      })
      .catch((error) => {
        setAddedAreas([]);
      });
  };

  const sortedMobileAreas = [...filteredAreaRows].sort(sortByDateDesc);
  const visibleMobileAreas = sortedMobileAreas.slice(0, visibleAreasCount);

  const sortedMobilePlants = [...addedPlants].sort(sortByDateDesc);
  const visibleMobilePlants = sortedMobilePlants.slice(0, visiblePlantsCount);

  const sortedMobileUsers = [...addedUsers].sort(sortByDateDesc);
  const visibleMobileUsers = sortedMobileUsers.slice(0, visibleUsersCount);

  return (
    <div>
      <div className="desktop-view">

        <Grid container style={{ padding: '10px 10px 10px ' }} justifyContent={"space-between"} alignItems={"center"} >
          <Grid item>
            <Tabs value={activeTab} onChange={handleTabChange} centered>
              <Tab label="User Details" value="user" style={tabStyle("user")} />

              <Tab label="Area Details" value="area" style={tabStyle("area")} />
              <Tab label="Plant Details" value="plant" style={tabStyle("plant")} />
            </Tabs>
          </Grid>

          <Grid item xl="4" lg="6" >
            <Grid
              container
              justifyContent={"flex-end"}
              alignItems={"center"}
              marginRight={1}
              gap={2}
            >
              {activeTab === "area" && (
                <Grid item md="3" >
                  <FormControl fullWidth size="small">
                    <InputLabel 
                      shrink={true} 
                      sx={{ 
                        color: '#64748b', 
                        fontSize: '13px', 
                        fontWeight: 500,
                        backgroundColor: '#ffffff',
                        px: 0.5,
                        '&.MuiInputLabel-shrink': {
                          transform: 'translate(14px, -6px) scale(0.75)'
                        }
                      }}
                    >
                      Filter Plant
                    </InputLabel>
                    <Select
                      className="select-nis"
                      value={areaFilter}
                      onChange={handleAreaFilterChange}
                      displayEmpty
                    >
                      <MenuItem value="">All </MenuItem>
                      {uniqueAreas.map((areaValue, index) => (
                        <MenuItem key={index} value={areaValue}>

                          {areaValue ? areaValue.toUpperCase() : ''}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {activeTab !== "plant" && (
                <Grid item md="5" >
                  <YearSelectBox
                    selectedYear={
                      activeTab === "user" ? selectedUserYear : selectedAreaYear
                    }
                    years={years}
                    onSelectedYearChange={handleSelectedYearChange}
                  />
                </Grid>
              )}
              {activeTab === "area" && userDet.role_id === 3 && (
                <Grid item md='3'>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    style={{ backgroundColor: '#002060' }}
                    onClick={handleAddAreaClick}
                  >
                    New Area
                  </Button>
                </Grid>
              )}
              {activeTab === "user" && (
                <Grid item>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    style={{ backgroundColor: '#002060' }}
                    onClick={handleAddUserClick}
                  >
                    New User
                  </Button>
                </Grid>
              )}
              {activeTab === "plant" && userDet.role_id === 3 && (
                <Grid item>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    style={{ backgroundColor: '#002060' }}
                    onClick={handleAddPlantClick}
                  >
                    New Plant
                  </Button>
                </Grid>
              )}

            </Grid>
          </Grid>
        </Grid>

        <Dialog open={confirmationModalOpen} onClose={handleCancelDelete}>
          <DialogTitle>Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button onClick={handleCancelDelete}>Cancel</Button>

            <Button
              onClick={handleConfirmDelete}
              variant="contained"
              color="primary"
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
        <div style={{ width: "100%", padding: '8px' }}>
          <DataGrid
            rows={paginatedRows}
            columns={columns}
            pageSize={rowsPerPage}
            checkboxSelection={false}
            autoHeight
            rowHeight={56}
            disableSelectionOnClick
            sx={{
              border: 'none',
              backgroundColor: '#ffffff',
              borderRadius: '12px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#f8fafc',
                borderBottom: '2px solid #e2e8f0',
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: '600 !important',
                color: '#334155 !important',
                fontSize: '14px !important',
              },
              '& .MuiDataGrid-row': {
                borderBottom: '1px solid #f1f5f9',
                '&:hover': {
                  backgroundColor: '#f8fafc',
                },
              },
              '& .MuiDataGrid-cell': {
                borderBottom: 'none',
                fontSize: '13.5px',
                color: '#475569',
              },
              '& .MuiDataGrid-footerContainer': {
                borderTop: '1px solid #e2e8f0',
              },
              '& .MuiDataGrid-columnSeparator': {
                display: 'none',
              }
            }}
          />
        </div>

        <AddArea
          open={addAreaModalOpen}
          onClose={handleAddAreaModalClose}
          onSave={handleSaveArea}
          selectedRowData={selectedRowData}
          selectedCardData={selectedCardData}
          addedAreas={currentaddedAreas}
          userDet={userDet}
          onHandleArea={getareaDetails}
          onShowAlertMessage={handleOpenAlert}
        />
        <AddUser
          open={addUserModalOpen}
          onHandleUser={getuserDetails}
          onClose={handleAddUserModalClose}

          onSave={handleSaveUser}
          onHandleUserDateList={getuserDateList}
          selectedRowUserData={selectedRowUserData}
          selectedUserCardData={selectedUserCardData}
          userDet={userDet}
          addedUsers={currentaddedUsers}
          onShowAlert={handleOpenAlert}
          selectedUserYear={selectedUserYear}
          setIsYearSelected={setIsYearSelected}

        />
        <AddPlant
          open={addPlantModalOpen}
          onClose={handleAddPlantModalClose}
          onSave={handleSavePlant}
          selectedRowPlantData={selectedRowPlantData}
          selectedPlantCardData={selectedPlantCardData}
          addedAreas={currentaddedPlants}
          userDet={userDet}
          onHandleArea={getplantDetails}
          onShowAlertMessage={handleOpenAlert}
        />
        <Snackbar
          open={alertOpen}
          autoHideDuration={3000}
          onClose={handleCloseAlert}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseAlert}
            severity="success"
          >
            {alertMessage}
          </MuiAlert>
        </Snackbar>
      </div>
      <div className="mobile-view">
        <Grid container justifyContent={'space-between'} alignItems={'center'} sx={{ mb: 2, px: '4px', pt: '8px' }}>
          <Grid item>
            <Typography sx={{ color: '#1e293b', fontSize: '18px', fontWeight: 700, fontFamily: 'var(--app-font)' }}>
              Settings
            </Typography>
          </Grid>
          <Grid item sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {activeTab === "area" && userDet.role_id === 3 && (
              <IconButton
                onClick={handleAddAreaClick}
                sx={{
                  backgroundColor: '#002060',
                  color: '#ffffff',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  '&:hover': {
                    backgroundColor: '#001a4e',
                  },
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
              >
                <AddIcon sx={{ fontSize: 22 }} />
              </IconButton>
            )}
            {activeTab === "user" && (
              <IconButton
                onClick={handleAddUserClick}
                sx={{
                  backgroundColor: '#002060',
                  color: '#ffffff',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  '&:hover': {
                    backgroundColor: '#001a4e',
                  },
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
              >
                <AddIcon sx={{ fontSize: 22 }} />
              </IconButton>
            )}
            {activeTab === "plant" && userDet.role_id === 3 && (
              <IconButton
                onClick={handleAddPlantClick}
                sx={{
                  backgroundColor: '#002060',
                  color: '#ffffff',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  '&:hover': {
                    backgroundColor: '#001a4e',
                  },
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
              >
                <AddIcon sx={{ fontSize: 22 }} />
              </IconButton>
            )}
          </Grid>
        </Grid>
        <Grid container style={{ padding: '0 4px 10px' }} alignItems={'center'} justifyContent={'space-between'}>
          <Grid item>
            <Typography style={{ fontSize: "12px", fontWeight: 400, color: "#8C8C8C" }}>
              Configure your system settings, users, and plants
            </Typography>
          </Grid>
        </Grid>
        <hr style={{ margin: '1px 0 16px 0', borderColor: '#0000001A' }} />

        <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange} 
            variant="fullWidth"
            sx={{
              '& .MuiTabs-indicator': {
                backgroundColor: '#002060',
                height: '3px',
                borderRadius: '3px',
              }
            }}
          >
            <Tab label="User Details" value="user" style={tabStyleMobile("user")} />
            <Tab label="Area Details" value="area" style={tabStyleMobile("area")} />
            <Tab label="Plant Details" value="plant" style={tabStyleMobile("plant")} />
          </Tabs>
        </Box>

        <Box sx={{ display: 'flex', gap: '8px', mb: 2, px: '4px', flexWrap: 'wrap' }}>
          {activeTab === "area" && (
            <FormControl size="small" sx={{ flex: 1, minWidth: '120px' }}>
              <InputLabel 
                shrink={true} 
                sx={{ 
                  color: '#64748b', 
                  fontSize: '13px', 
                  fontWeight: 500,
                  backgroundColor: '#ffffff',
                  px: 0.5,
                  '&.MuiInputLabel-shrink': {
                    transform: 'translate(14px, -6px) scale(0.75)'
                  }
                }}
              >
                Filter Plant
              </InputLabel>
              <Select
                className="select-nis"
                value={areaFilter}
                onChange={handleAreaFilterChange}
                displayEmpty
              >
                <MenuItem value="">All</MenuItem>
                {uniqueAreas.map((areaValue, index) => (
                  <MenuItem key={index} value={areaValue}>
                    {areaValue ? areaValue.toUpperCase() : ''}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {activeTab !== "plant" && (
            <FormControl size="small" sx={{ flex: 1, minWidth: '120px' }}>
              <YearSelectBox
                selectedYear={
                  activeTab === "user" ? selectedUserYear : selectedAreaYear
                }
                years={years}
                onSelectedYearChange={handleSelectedYearChange}
              />
            </FormControl>
          )}
        </Box>

        <Dialog open={confirmationModalOpen} onClose={handleCancelDelete}>
          <DialogTitle>Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button onClick={handleCancelDelete}>Cancel</Button>
            <Button
              onClick={handleConfirmDelete}
              variant="contained"
              color="primary"
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

        <div style={{ width: "100%", padding: '4px' }}>
          {activeTab === "area" ? (
            <Grid container spacing={2}>
              {visibleMobileAreas.map((data) => (
                <Grid item xs={12} sm={6} md={4} key={data.id}>
                  <Card sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    p: 2,
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    backgroundColor: '#ffffff'
                  }}>
                    <Box sx={{ mb: 1.5 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <Typography sx={{ fontWeight: 600, fontSize: '15px', color: '#002060' }}>
                          {data.area}
                        </Typography>
                        {userDet.role_id === 3 && (
                          <IconButton size="small" onClick={(event) => handleOpenMobileMenu(event, data)} sx={{ p: 0.5 }}>
                            <MoreVertIcon sx={{ fontSize: 20, color: '#64748b' }} />
                          </IconButton>
                        )}
                      </Box>
                      <Typography sx={{ fontSize: '12px', color: '#64748b', mt: 0.5 }}>
                        Plant: <Box component="span" sx={{ fontWeight: 500, color: '#1e293b' }}>{(data.plantName || '').toUpperCase()}</Box>
                      </Typography>
                      <Typography sx={{ fontSize: '12px', color: '#64748b' }}>
                        Loc/Biz: <Box component="span" sx={{ fontWeight: 500, color: '#1e293b' }}>{(data.location || '').toUpperCase()} / {(data.business_name || '').toUpperCase()}</Box>
                      </Typography>
                      {data.description && (
                        <Typography sx={{ fontSize: '12px', color: '#64748b', mt: 1, fontStyle: 'italic' }}>
                          {data.description}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #f1f5f9', pt: 1, mt: 'auto' }}>
                      <Typography sx={{ fontSize: '11px', color: '#94a3b8' }}>
                        By: {data.name}
                      </Typography>
                      <Typography sx={{ fontSize: '11px', color: '#94a3b8' }}>
                        {data.created_on?.split('T')[0] || ''}
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              ))}
              {sortedMobileAreas.length > visibleAreasCount && (
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                  <Button
                    variant="outlined"
                    onClick={() => setVisibleAreasCount(prev => prev + 10)}
                    sx={{
                      color: '#002060',
                      borderColor: '#002060',
                      borderRadius: '8px',
                      textTransform: 'none',
                      fontWeight: 600,
                      px: 3,
                      '&:hover': {
                        backgroundColor: '#f1f5f9',
                        borderColor: '#001a4e',
                      }
                    }}
                  >
                    Load More (showing {visibleAreasCount} of {sortedMobileAreas.length})
                  </Button>
                </Grid>
              )}
            </Grid>
          ) : activeTab === "plant" ? (
            <Grid container spacing={2}>
              {visibleMobilePlants.map((data) => (
                <Grid item xs={12} sm={6} md={4} key={data.id}>
                  <Card sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    p: 2,
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    backgroundColor: '#ffffff'
                  }}>
                    <Box sx={{ mb: 1.5 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <Typography sx={{ fontWeight: 600, fontSize: '15px', color: '#002060' }}>
                          {data.plantName}
                        </Typography>
                        {userDet.role_id === 3 && (
                          <IconButton size="small" onClick={(event) => handleOpenMobileMenu(event, data)} sx={{ p: 0.5 }}>
                            <MoreVertIcon sx={{ fontSize: 20, color: '#64748b' }} />
                          </IconButton>
                        )}
                      </Box>
                      <Typography sx={{ fontSize: '12px', color: '#64748b', mt: 0.5 }}>
                        Category: <Box component="span" sx={{ fontWeight: 500, color: '#1e293b' }}>{data.category_name || ''}</Box>
                      </Typography>
                      <Typography sx={{ fontSize: '12px', color: '#64748b' }}>
                        Loc/Biz: <Box component="span" sx={{ fontWeight: 500, color: '#1e293b' }}>{(data.location || '').toUpperCase()} / {(data.business_name || '').toUpperCase()}</Box>
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #f1f5f9', pt: 1, mt: 'auto' }}>
                      <Typography sx={{ fontSize: '11px', color: '#94a3b8' }}>
                        By: {data.name}
                      </Typography>
                      <Typography sx={{ fontSize: '11px', color: '#94a3b8' }}>
                        {data.created_on?.split('T')[0] || ''}
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              ))}
              {sortedMobilePlants.length > visiblePlantsCount && (
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                  <Button
                    variant="outlined"
                    onClick={() => setVisiblePlantsCount(prev => prev + 10)}
                    sx={{
                      color: '#002060',
                      borderColor: '#002060',
                      borderRadius: '8px',
                      textTransform: 'none',
                      fontWeight: 600,
                      px: 3,
                      '&:hover': {
                        backgroundColor: '#f1f5f9',
                        borderColor: '#001a4e',
                      }
                    }}
                  >
                    Load More (showing {visiblePlantsCount} of {sortedMobilePlants.length})
                  </Button>
                </Grid>
              )}
            </Grid>
          ) : (
            <Grid container spacing={2}>
              {visibleMobileUsers.map((data) => (
                <Grid item xs={12} sm={6} md={4} key={data.id}>
                  <Card sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    p: 2,
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    backgroundColor: '#ffffff'
                  }}>
                    <Box sx={{ mb: 1.5 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <Typography sx={{ fontWeight: 600, fontSize: '15px', color: '#002060' }}>
                          {data.name}
                        </Typography>
                        {(userDet.role_id === 3 || ['admin', 'User'].includes(data.role_name)) && (
                          <IconButton size="small" onClick={(event) => handleOpenMobileMenu(event, data)} sx={{ p: 0.5 }}>
                            <MoreVertIcon sx={{ fontSize: 20, color: '#64748b' }} />
                          </IconButton>
                        )}
                      </Box>
                      <Typography sx={{ fontSize: '12px', color: '#64748b', mt: 0.5 }}>
                        Role: <Box component="span" sx={{ fontWeight: 500, color: '#1e293b' }}>{data.role_name}</Box>
                      </Typography>
                      <Typography sx={{ fontSize: '12px', color: '#64748b' }}>
                        Email: <Box component="span" sx={{ fontWeight: 500, color: '#1e293b' }}>{data.email}</Box>
                      </Typography>
                      <Typography sx={{ fontSize: '12px', color: '#64748b' }}>
                        SGID: <Box component="span" sx={{ fontWeight: 500, color: '#1e293b' }}>{data.sgid}</Box>
                      </Typography>
                      {data.plant_name && data.plant_name.length > 0 && (
                        <Typography sx={{ fontSize: '12px', color: '#64748b' }}>
                          Plants: <Box component="span" sx={{ fontWeight: 500, color: '#1e293b' }}>{data.plant_name.map(p => p.toUpperCase()).join(', ')}</Box>
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #f1f5f9', pt: 1, mt: 'auto' }}>
                      <Typography sx={{ fontSize: '11px', color: '#94a3b8' }}>
                        By: {data.created_by}
                      </Typography>
                      <Typography sx={{ fontSize: '11px', color: '#94a3b8' }}>
                        {data.created_on?.split('T')[0] || ''}
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              ))}
              {sortedMobileUsers.length > visibleUsersCount && (
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                  <Button
                    variant="outlined"
                    onClick={() => setVisibleUsersCount(prev => prev + 10)}
                    sx={{
                      color: '#002060',
                      borderColor: '#002060',
                      borderRadius: '8px',
                      textTransform: 'none',
                      fontWeight: 600,
                      px: 3,
                      '&:hover': {
                        backgroundColor: '#f1f5f9',
                        borderColor: '#001a4e',
                      }
                    }}
                  >
                    Load More (showing {visibleUsersCount} of {sortedMobileUsers.length})
                  </Button>
                </Grid>
              )}
            </Grid>
          )}
        </div>

        <AddArea
          open={addAreaModalOpen}
          onClose={handleAddAreaModalClose}
          onSave={handleSaveArea}
          selectedCardData={selectedCardData}
          selectedRowData={selectedRowData}
          addedAreas={currentaddedAreas}
          userDet={userDet}
          onHandleArea={getareaDetails}
          onShowAlertMessage={handleOpenAlert}
        />

        <AddUser
          open={addUserModalOpen}
          onHandleUser={getuserDetails}
          onClose={handleAddUserModalClose}
          onSave={handleSaveUser}
          selectedUserCardData={selectedUserCardData}
          selectedRowUserData={selectedRowUserData}
          userDet={userDet}
          addedUsers={currentaddedUsers}
          onShowAlert={handleOpenAlert}
          onHandleUserDateList={getuserDateList}
          selectedUserYear={selectedUserYear}
          setIsYearSelected={setIsYearSelected}
        />
        <AddPlant
          open={addPlantModalOpen}
          onClose={handleAddPlantModalClose}
          onSave={handleSavePlant}
          selectedRowPlantData={selectedRowPlantData}
          selectedPlantCardData={selectedPlantCardData}
          addedAreas={currentaddedPlants}
          userDet={userDet}
          onHandleArea={getplantDetails}
          onShowAlertMessage={handleOpenAlert}
        />

        <Snackbar
          open={alertOpen}
          autoHideDuration={3000}
          onClose={handleCloseAlert}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseAlert}
            severity="success"
          >
            {alertMessage}
          </MuiAlert>
        </Snackbar>

        <Menu
          anchorEl={mobileMenuAnchor}
          open={Boolean(mobileMenuAnchor)}
          onClose={handleCloseMobileMenu}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <MenuItem 
            onClick={() => {
              handleEdit(activeCardData);
              handleCloseMobileMenu();
            }}
          >
            <EditIcon style={{ width: '16px', height: '16px', marginRight: '8px', fill: '#475569' }} />
            Edit
          </MenuItem>
          <MenuItem 
            onClick={() => {
              setSelectedDeleteItem(activeCardData);
              setConfirmationModalOpen(true);
              handleCloseMobileMenu();
            }}
            sx={{ color: '#ef4444', '&:hover': { color: '#ef4444' } }}
          >
            <DeleteIcon style={{ width: '16px', height: '16px', marginRight: '8px', fill: '#ef4444' }} />
            Delete
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
}

export default Settings;
